function Clearfix() {
  return <div className="clearfix" />;
}

export default Clearfix;
